<template>
  <div class="relative inline-block">
    <button
      ref="triggerRef"
      @click="open = !open"
      @mouseenter="open = true"
      @mouseleave="open = false"
      @blur="open = false"
      :aria-describedby="open ? tooltipId : undefined"
      @keydown.space.prevent="open = !open"
      @keydown.enter.prevent="open = !open"
      @keydown.esc.prevent="open = false"
      aria-label="Tooltip information"
    >
      <slot name="trigger" />
    </button>

    <div
      v-if="open"
      class="absolute z-50 tooltip-box"
      :class="tooltipPositionClass"
      role="tooltip"
      :id="tooltipId"
      :aria-hidden="!open"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, useId } from 'vue'

const props = withDefaults(
  defineProps<{
    placement?: 'top' | 'bottom'
  }>(),
  {
    placement: 'bottom'
  }
)

const open = ref(false)

const tooltipId = useId();

const tooltipPositionClass = computed(() => {
  return props.placement === 'top'
    ? 'bottom-full mb-2 left-1/2 -translate-x-1/2'
    : 'top-full mt-2 left-1/2 -translate-x-1/2'
})
</script>
